import {FeatureFlags} from '~commonInfra/featureFlags/FeatureFlags';
import {getSessionManagementServiceInstance} from '~src/sessionManagement/SessionManagementService';

export module CollectionUtils {
  /*
  If collectionsSiteSetting FF is On:
  check to see site settings value to enable collections
  If collectionsSiteSetting FF is Off:
  enable collections.
  */
  export const checkCollectionSiteSetting: () => (boolean) = () => {
    const isCollectionsEnabled = getSessionManagementServiceInstance().isCollectionsEnabledOnSite();
    return FeatureFlags.collectionsSiteSetting ? isCollectionsEnabled : true;
  };
}